export const CREATE_ORDER = 'CREATE_ORDER';
export const LOAD_COMPROBATION = 'LOAD_COMPROBATION';
export const LOAD_COMPROBATION_ERROR = 'LOAD_COMPROBATION_ERROR';
export const CLOSE_ORDER = 'CLOSE_ORDER';
export const ADD_ORDER_ITEM = 'ADD_ORDER_ITEM';
export const REMOVE_ORDER_ITEM = 'REMOVE_ORDER_ITEM';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const LOAD_COMPROBATION_SUCCESS = 'LOAD_COMPROBATION_SUCCESS';
export const CLEAR_PURCHARSE_ORDER_STORE = 'CLEAR_PURCHARSE_ORDER_STORE';
